import { IPlanPassenger } from "@/types/tasks.types";

import { PassengerColumnCell } from "./table/PassengerColumn";

function PassengerInfoCard({ passenger }: { passenger: IPlanPassenger<"db"> }) {
    return (
        <div className="border-b border-gray-200 mb-3 pb-2 -translate-x-2  flex justify-between items-center">
            <PassengerColumnCell
                passengerClassName="text-normal gap-2"
                avatarVariant="circular"
                avatarSize={32}
                row={passenger as unknown as IPlanPassenger<"api">}
                value={passenger.name}
                raw={false}
            />
        </div>
    );
}

export default PassengerInfoCard;
